export const UsageTrackingParams = {
    communityQuestionsViewed: 'communityQuestionsViewed',
    openedDaysCount: 'openedDaysCount',
    durationInMin: 'durationInMin',
};
